<template>
	<div id="score-list">

		<v-switch
			color="accent"
			:label="switchText"
			v-model="isCardUI">
		</v-switch>

		<v-row
			id="score-cards"
			v-show="isCardUI"
		>
			<v-col
				cols="12"
				sm="6"
				md="4"
				lg="3"
				xl="3"
				v-for="score in scores"
				:key="score['number']"
			>
				<ScoreCard
					:score="score"
				/>
			</v-col>
		</v-row>

		<table
			id="score-list-table"
			v-show="!isCardUI"
		>
			<tr id="score-list-table-header-row">
				<th class="score-list-table-header">作品番号</th>
				<th class="score-list-table-header">タイトル</th>
				<th class="score-list-table-header">音楽</th>
				<th class="score-list-table-header">難易度</th>
				<th class="score-list-table-header">コメント</th>
				<th class="score-list-table-header">長さ</th>
				<th class="score-list-table-header">作成日</th>
			</tr>
			<tr v-for="score in scores" :key="score['number']">
				<td class="score-number">No.{{ score['number'] }}</td>
				<td class="score-title">
					<ScoreTitle :title="score['title']" :scoreURL="score['page-url']" :name="score['source']"></ScoreTitle>
				</td>
				<td class="score-artist">
					<ScoreArtist :artist="score['artist']" :artistURL="score['artist-url']"></ScoreArtist>
				</td>
				<td class="score-difficult">
					<ScoreDifficulty :diffArray="score['difficult']"></ScoreDifficulty>
				</td>
				<td class="score-comment" v-html="score['list-comment']"></td>
				<td class="score-length">{{ score['length'] }}</td>
				<td class="score-update">{{ score['update'] }}</td>
			</tr>
		</table>
	</div>
</template>

<script>
import scores from '../../assets/scorelist.json';
import ScoreTitle from './ScoreTitle.vue';
import ScoreArtist from './ScoreArtist.vue';
import ScoreDifficulty from './ScoreDifficulty.vue';
import ScoreCard from './ScoreCard.vue';


	export default {
		components: {
			ScoreTitle,
			ScoreArtist,
			ScoreDifficulty,
			ScoreCard,
		},
		data: () => {
			return {
				// No降順でソートして表示
				scores: scores.filter(score => {
							return !score['invisible'];
						}).sort((scoreA, scoreB) => {
							return (scoreA['number'] < scoreB['number'] ? 1 : -1); 
						}),

				isCardUI: true, // 初期値true, 以降はローカルストレージの値を利用
			}
		},
		computed: {
			// UI変更トグルのラベル
			switchText() {
				// console.log(localStorage.isCardUI);
				if(this.isCardUI) {
					return 'New Card UI';
				}else {
					return 'Old List UI';
				}
			}
		},
		mounted() {
			if(localStorage.isCardUI) {
				// 'false' → true なので真偽値ではなく文字列で分岐させる
				if(localStorage.isCardUI === 'true') {
					this.isCardUI = true;
				} else {
					this.isCardUI = false;
				}
				
			}
		},
		watch: {
			isCardUI(value) {
				localStorage.isCardUI = value;
			}
		}
	}
</script>

<style scoped>
	.bigger-level-star {
		color: #F44336;
	}

	table, td, th {
		border-collapse: collapse;
		border: 1px #757575 solid;
	}
	td {
		text-align: center;
	}

	.difficulty-explanation {
		margin: 16px 0;
	}

	.difficulty-explanation td,
	.difficulty-explanation caption {
		text-align: left;
	}

	#score-list-table {
    width: 100%;
	}

	.score-title,
	.score-artist,
	.score-comment,
	.score-length,
	.score-difficult,
	.score-update {
		padding: 4px 8px;
	}
	.score-difficult *,
	.score-comment {
		text-align: left;
	}
	
</style>